module.exports = __webpack_public_path__ + "78f26ce590d4cba7e8a67c4ffdee19b4.png";